import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type { AdminDataPlan, AdminDataPlansResponse } from '@/types/data';

class AdminDataService {
  listPlans() {
    return apiClient.get<ApiResponse<AdminDataPlansResponse>>('/admins/data/plans');
  }

  updatePlan(
    id: number,
    payload: Partial<
      Pick<AdminDataPlan, 'subscriberPrice' | 'agentPrice' | 'providerCost' | 'isActive' | 'description'>
    >,
  ) {
    return apiClient.put<ApiResponse<{ plan: AdminDataPlan }>>(`/admins/data/plans/${id}`, payload);
  }
}

export const adminDataService = new AdminDataService();
